export default function safeUrl(url: string) {
  return process.env.PUBLIC_URL === undefined ? url : `${process.env.PUBLIC_URL}${url}`;
}



// WEBPACK FOOTER //
// ./src/util/safeUrl.js